export default __webpack_public_path__ + "static/media/HooRayForHerbie60s.dff4b1b3.mp3";